module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "ods-cadastro-main-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ods-cadastro-content-container"
  }, [(_vm.editando == false) ? _c('div', {
    staticClass: "ods-button-alterar-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editando = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Editar Cadastro de Favoritos ODS")])]) : _vm._e(), _vm._v(" "), (_vm.editando == false) ? _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "idOds",
      fn: function(row) {
        return [_c('div', {
          class: 'cor-' + row.item.idOds
        }, [_c('img', {
          staticClass: "ods-img",
          attrs: {
            "src": _vm.getImageODS(row.item.idOds),
            "alt": "ODS IMG"
          }
        })])]
      }
    }], null, false, 703124086)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editando == true) ? _c('div', {
    staticClass: "ods-check-main-container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((this.baseODS), function(ods) {
    return _c('div', {
      staticClass: "ods-base"
    }, [_c('div', {
      staticClass: "base-ods-row"
    }, [_c('div', {
      staticClass: "base-ods-content",
      on: {
        "click": function($event) {
          return _vm.toggleMeta(ods.id)
        }
      }
    }, [_c('div', {
      staticClass: "ods-text-container",
      class: 'cor-' + ods.id
    }, [_c('div', {
      staticClass: "ods-id"
    }, [_vm._v("\n                        " + _vm._s(ods.id) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "ods-descricao"
    }, [_vm._v("\n                        " + _vm._s(ods.descricao) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "ods-img-container",
      class: 'cor-' + ods.id
    }, [_c('img', {
      staticClass: "ods-img",
      attrs: {
        "src": _vm.getImageODS(ods.id),
        "alt": "ODS IMG"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "ods-carret",
      class: {
        'ods-indicador': ods.abrirMeta
      },
      attrs: {
        "src": _vm.getImageODS('caret'),
        "alt": "ODS IMG"
      }
    })])])]), _vm._v(" "), (ods.abrirMeta) ? _c('div', {
      staticClass: "ods-metas-indicador"
    }, [_c('i', {
      staticClass: "fa fa-check-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Metas\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((ods.metas), function(meta) {
      return (ods.abrirMeta) ? _c('div', {
        staticClass: "ods-meta-base"
      }, [_c('div', {
        staticClass: "base-ods-row"
      }, [_c('div', {
        staticClass: "base-ods-content",
        on: {
          "click": function($event) {
            return _vm.toggleIndicador(ods.id, meta.id)
          }
        }
      }, [_c('div', {
        staticClass: "ods-meta-text-container",
        class: 'cor-' + ods.id
      }, [_vm._v("\n                      " + _vm._s(meta.descricao) + "\n                    ")]), _vm._v(" "), _c('label', {
        staticClass: "ods-check-container",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meta.selecionado),
          expression: "meta.selecionado"
        }],
        staticClass: "ods-check",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(meta.selecionado) ? _vm._i(meta.selecionado, null) > -1 : (meta.selecionado)
        },
        on: {
          "change": function($event) {
            var $$a = meta.selecionado,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(meta, "selecionado", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(meta, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(meta, "selecionado", $$c)
            }
          }
        }
      })])])])]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "ods-button-cadastro-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.salvarODS
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editando = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Cancelar")])])], 2) : _vm._e()], 1), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ods-input-container"
  }, [_vm._v("\n             Selecione as Metas e clique em "), _c('strong', [_vm._v("Salvar")]), _vm._v(" abaixo para definir os favoritos.\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-279c1892!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/odsCadastro.vue
// module id = 1892
// module chunks = 1